import { render } from "./MyStore.vue?vue&type=template&id=210cf4f5&scoped=true"
import script from "./MyStore.vue?vue&type=script&lang=js"
export * from "./MyStore.vue?vue&type=script&lang=js"

import "./MyStore.vue?vue&type=style&index=0&id=210cf4f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210cf4f5"]])

export default __exports__